/**
 * Reusable edit component with bootstrap
 *
 * Example:
 *  <ma-edit input-label="Tien nimi" ng-model="vm.app.prcName"></app-edit>
 *
 * Supports following optional attributes:
 *  required    - HTML required, if set field is required (but can be overridden by ng-required)
 *  ng-required - passed as ng-required to input element
 *  m-size      - additional css class for input, see input-lg / input-sm in bootstrap
 *  m-short     - short input f.e. for numbers, disables also placeholder. NOTE: implemented only for inputs with addon
 *  m-help      - content going into paragraph styled as help-block (html/text)
 *  input-addon - unit or other text going into bootstrap input addon
 *
 * Notes
 *  - input-label is bound once inside the component template -> label cannot be changed once
 *    * this can be changed by removing :: from {::vm.inputLabel}} however we dont add extra watches
 *      unless the behavior becomes necessary
 */
export const maEditTextComponent = {
    bindings: {
        ngModel: '=',
        ngRequired: '=',
        help: '@',
        inputLabel: '@',
        inputAddon: '@',
    },
    require: {
        ngModelCtrl: "ngModel",
        form: '^form' // binds form to controller
    },
    template: ['$element', '$attrs', TemplateBuilder],
    controller: ['$element', AppEditCtrl],
    controllerAs: 'vm'
};
function AppEditCtrl($element) {
    const vm = this;
    this.$onInit = function () {
        vm.isRequired = function () {
            // Returns true if the input element editor has the 'required' attribute.
            // The attribute may be set by ng-required or required on the directive element.
            return !!($element.find('input').attr('required'));
        };
    };
}
function TemplateBuilder($element, $attrs) {
    // generate input id by ng-model and random number, removing all non-word characters (allows _ though)
    // regex \W is negation shorthand for \w
    const inputId = $attrs.inputId || ('fld' + $attrs.ngModel + Math.random()).replace(/\W+/g, '');
    let htmlInputType = 'text'; // text by default
    if ($attrs.mType == 'email') {
        htmlInputType = 'email';
    }
    const required = $attrs.required !== undefined ? 'required="true"' : '';
    const html = [];
    html.push(`<div class="form-group" ng-class="{ 'has-error' : vm.form.${inputId}.$invalid }">`);
    html.push(`<label for="${inputId}" translate>{{::vm.inputLabel}}</label>`);
    html.push(`<input type="${htmlInputType}" ${required} class="form-control" id="${inputId}" name="${inputId}" ng-model="vm.ngModel"></input>`);
    html.push(`<div ng-messages="vm.form.${inputId}.$error" role="alert">`);
    html.push('<p ng-message="required" class="help-block bg-danger" translate>EDIT_PAKOLLINEN_TIETO</p>');
    html.push('<p ng-message="email" class="help-block bg-danger" translate>EDIT_VIRHEELLINEN_EMAIL</p>');
    html.push('</div>');
    if ($attrs.help) {
        html.push('<p class="help-block">{{::vm.help}}</p>');
    }
    html.push(`</div>`); // form-group
    return html.join("\n");
} // buildTemplate
